import { Type } from '@angular/core';
import { AccordionComponent } from '@nibtravel/shared/ui/components/accordion';
import { AlertComponent } from '@nibtravel/shared/ui/components/alert';
import { ButtonLinkComponent } from '@nibtravel/shared/ui/components/button';
import { CalloutComponent } from '@nibtravel/shared/ui/components/callout';
import { HeroComponent } from '@nibtravel/shared/ui/components/hero';
import { IconComponent } from '@nibtravel/shared/ui/components/icon';
import { LinkIconComponent } from '@nibtravel/shared/ui/components/link-icon';
import { PanelComponent } from '@nibtravel/shared/ui/components/panel';
import { TableComponent } from '@nibtravel/shared/ui/components/table';

import { WrapperComponent } from '../wrapper/wrapper.component';

/** An enum that represents the content type defined within contentful */
export enum ComponentTypes {
  Accordion = 'accordion',
  Alert = 'alert',
  Button = 'button',
  Callout = 'callout',
  Component = 'component',
  Hero = 'hero',
  Icon = 'icon',
  Link = 'link',
  Panel = 'panel',
  Table = 'table',
}

/** A type created to satisfy typescript for the supported White Label supported components  */
export type SupportedTypes =
  | AccordionComponent
  | AlertComponent
  | ButtonLinkComponent
  | CalloutComponent
  | HeroComponent
  | IconComponent
  | LinkIconComponent
  | PanelComponent
  | TableComponent
  | WrapperComponent;

/** A simple object map to correlate the contentful types to the White Label Components */
export const SupportedUITypeMap: Record<string, Type<SupportedTypes>> = {
  [ComponentTypes.Accordion]: AccordionComponent,
  [ComponentTypes.Alert]: AlertComponent,
  [ComponentTypes.Button]: ButtonLinkComponent,
  [ComponentTypes.Callout]: CalloutComponent,
  [ComponentTypes.Component]: WrapperComponent,
  [ComponentTypes.Hero]: HeroComponent,
  [ComponentTypes.Icon]: IconComponent,
  [ComponentTypes.Link]: LinkIconComponent,
  [ComponentTypes.Panel]: PanelComponent,
  [ComponentTypes.Table]: TableComponent,
};
